/* esm.sh - ms@2.1.3 */
export * from "/*ms@2.1.3/esnext/ms.mjs";
export { default } from "/*ms@2.1.3/esnext/ms.mjs";
